"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameSetupDetail = void 0;
const vue_1 = require("vue");
const BoardName_1 = require("../boards/BoardName");
const RandomMAOptionType_1 = require("../RandomMAOptionType");
const PoliticalAgendas_1 = require("../turmoil/PoliticalAgendas");
exports.GameSetupDetail = vue_1.default.component('game-setup-detail', {
    props: {
        playerNumber: {
            type: Number,
        },
        gameOptions: {
            type: Object,
        },
        lastSoloGeneration: {
            type: Number,
        },
    },
    methods: {
        isPoliticalAgendasOn: function () {
            return this.gameOptions.politicalAgendasExtension !== PoliticalAgendas_1.AgendaStyle.STANDARD;
        },
        isSocietyExpansionOn: function () {
            return this.gameOptions.societyExpansion === true;
        },
        isLeadersExpansionOn: function () {
            return this.gameOptions.leadersExpansion === true;
        },
        isNewOpsExpansionOn: function () {
            return this.gameOptions.newOpsExpansion === true;
        },
        isArchaeologyExtensionOn: function () {
            return this.gameOptions.archaeologyExtension === true;
        },
        isSilverCubeVariantOn: function () {
            return this.gameOptions.silverCubeVariant === true;
        },
        getBoardColorClass: function (boardName) {
            switch (boardName) {
                case BoardName_1.BoardName.ORIGINAL:
                    return 'game-config board-tharsis map';
                case BoardName_1.BoardName.HELLAS:
                    return 'game-config board-hellas map';
                case BoardName_1.BoardName.ELYSIUM:
                    return 'game-config board-elysium map';
                case BoardName_1.BoardName.AMAZONIS:
                    return 'game-config board-amazonis map';
                case BoardName_1.BoardName.ARABIA_TERRA:
                    return 'game-config board-arabia_terra map';
                case BoardName_1.BoardName.UTOPIA_PLANITIA:
                    return 'game-config board-utopia_planitia map';
                case BoardName_1.BoardName.VASTITAS_BOREALIS:
                    return 'game-config board-vastitas_borealis map';
                case BoardName_1.BoardName.TERRA_CIMMERIA:
                    return 'game-config board-terra_cimmeria map';
                case BoardName_1.BoardName.LABYRINTHUS:
                    return 'game-config board-labyrinthus map';
                default:
                    return 'game-config board-other map';
            }
        },
        isRandomMANone: function () {
            return this.gameOptions.randomMA === RandomMAOptionType_1.RandomMAOptionType.NONE;
        },
        isRandomMALimited: function () {
            return this.gameOptions.randomMA === RandomMAOptionType_1.RandomMAOptionType.LIMITED;
        },
        isRandomMAUnlimited: function () {
            return this.gameOptions.randomMA === RandomMAOptionType_1.RandomMAOptionType.UNLIMITED;
        },
    },
    template: `
        <div id="game-setup-detail" class="game-setup-detail-container">
          <ul>
            <li><div class="setup-item" v-i18n>Expansion:</div>
              <div v-if="gameOptions.venusNextExtension" class="create-game-expansion-icon expansion-icon-venus"></div>
              <div v-if="gameOptions.preludeExtension" class="create-game-expansion-icon expansion-icon-prelude"></div>
              <div v-if="gameOptions.coloniesExtension" class="create-game-expansion-icon expansion-icon-colony"></div>
              <div v-if="gameOptions.turmoilExtension" class="create-game-expansion-icon expansion-icon-turmoil"></div>
              <div v-if="gameOptions.promoCardsOption" class="create-game-expansion-icon expansion-icon-promo"></div>
              <div v-if="gameOptions.automaSoloVariant" class="create-game-expansion-icon expansion-icon-automa"></div>
              <div v-if="gameOptions.preludeTwoExtension" class="create-game-expansion-icon expansion-icon-prelude-two"></div>
              <div v-if="isArchaeologyExtensionOn()" class="create-game-expansion-icon expansion-icon-archaeology"></div>
              <div v-if="gameOptions.aresExtension" class="create-game-expansion-icon expansion-icon-ares"></div>
              <div v-if="gameOptions.moonExpansion" class="create-game-expansion-icon expansion-icon-themoon"></div>
              <div v-if="gameOptions.communityCardsOption" class="create-game-expansion-icon expansion-icon-community"></div>
              <div v-if="isPoliticalAgendasOn()" class="create-game-expansion-icon expansion-icon-agendas"></div>
              <div v-if="isSocietyExpansionOn()" class="create-game-expansion-icon expansion-icon-society"></div>
              <div v-if="isSilverCubeVariantOn()" class="create-game-expansion-icon expansion-icon-silver-cube"></div>
              <div v-if="isNewOpsExpansionOn()" class="create-game-expansion-icon expansion-icon-newOps"></div>
              <div v-if="isLeadersExpansionOn()" class="create-game-expansion-icon expansion-icon-leaders"></div>
            </li>

            <li><div class="setup-item" v-i18n>Board:</div>
              <span :class="getBoardColorClass(gameOptions.boardName)" v-i18n>{{ gameOptions.boardName }}</span>
              &nbsp;
              <span v-if="gameOptions.shuffleMapOption" class="game-config generic" v-i18n>(randomized tiles)</span>
            </li>

            <li><div class="setup-item" v-i18n>WGT:</div>
              <div v-if="gameOptions.solarPhaseOption" class="game-config generic" v-i18n>On</div>
              <div v-else class="game-config generic" v-i18n>Off</div>
            </li>
            <li v-if="gameOptions.requiresVenusTrackCompletion">Require Terraforming Venus to end the game</li>
            <li v-if="gameOptions.requiresMoonTrackCompletion">Require Terraforming The Moon to end the game</li>

            <li v-if="playerNumber > 1">
              <div class="setup-item" v-i18n>Milestones and Awards:</div>
              <div v-if="isRandomMANone()" class="game-config generic" v-i18n>Board-defined</div>
              <div v-if="isRandomMALimited()" class="game-config generic" v-i18n>Randomized with limited synergy</div>
              <div v-if="isRandomMAUnlimited()" class="game-config generic" v-i18n>Full randomized</div>
            </li>

            <li v-if="playerNumber > 1">
              <div class="setup-item" v-i18n>Draft:</div>
              <div v-if="gameOptions.initialDraftVariant" class="game-config generic" v-i18n>Initial</div>
              <div v-if="gameOptions.draftVariant" class="game-config generic" v-i18n>Research phase</div>
              <div v-if="!gameOptions.initialDraftVariant && !gameOptions.draftVariant" class="game-config generic" v-i18n>Off</div>
            </li>

            <li v-if="gameOptions.escapeVelocityMode">
              <div class="create-game-expansion-icon expansion-icon-escape-velocity"></div>
              <span>After {{gameOptions.escapeVelocityThreshold}} min, reduce {{gameOptions.escapeVelocityPenalty}} VP every {{gameOptions.escapeVelocityPeriod}} min.</span>
            </li>

            <li v-if="playerNumber === 1">
              <div class="setup-item" v-i18n>Solo:</div>
              <div class="game-config generic" v-i18n>{{ this.lastSoloGeneration }} Gens</div>
              <div v-if="gameOptions.soloTR" class="game-config generic" v-i18n>63 TR</div>
              <div v-else class="game-config generic" v-i18n>TR all</div>
            </li>

            <li><div class="setup-item" v-i18n>Game configs:</div>
              <div v-if="gameOptions.fastModeOption" class="game-config fastmode" v-i18n>fast mode</div>
              <div v-if="gameOptions.twoCorpsVariant" class="game-config merger" v-i18n>merger</div>
              <div v-if="gameOptions.showTimers" class="game-config timer" v-i18n>timer</div>
              <div v-if="gameOptions.undoOption" class="game-config undo" v-i18n>undo</div>
              <div v-if="gameOptions.singleTradeVariant" class="game-config single-trade" v-i18n>single trade</div>
              <div v-if="gameOptions.equalOpportunityVariant" class="game-config equal-opportunity" v-i18n>equal opportunity</div>
            </li>

            <li v-if="gameOptions.cardsBlackList.length > 0"><div class="setup-item" v-i18n>Banned cards:</div>{{ gameOptions.cardsBlackList.join(', ') }}</li>
          </ul>
        </div>
    `,
});
//# sourceMappingURL=GameSetupDetail.js.map